import { gql } from '@apollo/client';
import { doctorBaseData } from 'services/query/doctors';

export const CREATE_DOCTOR = gql`
  mutation createDoctor($data: CreateDoctorInput!) {
    createDoctor(data: $data) {
      id
    }
  }
`;

export const UPDATE_DOCTOR = gql`
  mutation updateDoctor($data: UpdateDoctorInput!) {
    updateDoctor(data: $data) {
      ${doctorBaseData}
    }
  }
`;

export const DELETE_DOCTOR = gql`
  mutation deleteDoctor($id: String!) {
    deleteDoctor(id: $id)
  }
`;

export const RESTORE_DOCTOR = gql`
  mutation restoreDoctor($id: ID!) {
    restoreDoctor(id: $id) {
      id
    }
  }
`;
